import { styled } from '@mui/material/styles';

const StyledMobileStepper = styled('div')`
  .mobile-stepper {
    background: unset;
  }
`;

export { StyledMobileStepper };
